import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const LondonIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_1158_10688)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M13.694 14.0859H6.75195V20.9528H13.694V14.0859Z",
                        fill: "#FFCB00"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M14.3706 13.6133H6V6.77148H14.3455V13.6133H14.3706ZM10.1853 12.0344C11.2128 12.0344 12.0398 11.2074 12.0398 10.1799C12.0398 9.15233 11.2128 8.3253 10.1853 8.3253C9.15775 8.3253 8.33072 9.15233 8.33072 10.1799C8.33072 11.2074 9.15775 12.0344 10.1853 12.0344Z",
                        fill: "#FFCB00"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.1854 5.96588H13.6188V4.61255C13.6188 3.86071 12.1151 4.03614 12.1151 4.03614V2.1064H11.5387L10.1854 -0.5L8.83206 2.08134H8.25565V4.03614C8.25565 4.03614 6.75195 3.86071 6.75195 4.61255V5.96588H10.1854Z",
                        fill: "#FFCB00"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_1158_10688",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
